import axios from "axios";

export default {
  namespaced: true,
  state: {
    gljournals: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    gljournalsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    CLEAR_GLJOURNALS(state) {
      state.gljournals = [];
    },
    RECEIVED_GLJOURNALS(state, payload) {
      state.gljournals = payload;
      state.isReceiving = false;
    },
    RECEIVING_GLJOURNALS(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },
    RECEIVED_GLJOURNAL(state, payload) {
      state = Object.assign(state, {
        gljournals: [...state.gljournals, payload],
        isReceiving: false,
      })
    },
    RECEIVING_GLJOURNAL(state) {
      state.isReceiving = true;
    },
    UPDATED_GLJOURNAL(state, payload) {
      let index = state.gljournals.findIndex(gljournal => gljournal._id === payload._id);
      state = Object.assign(state, {
        gljournals: state.gljournals.map((gljournal, i) => {
          if (i === index) {
            return Object.assign({}, gljournal, payload);
          }
          return gljournal;
        }),
        isUpdating: false,
        gljournalsMessage: 'GLJournals has been updating!',
      })
    },
    UPDATING_GLJOURNAL(state) {
      state.isUpdating = true;
    },
    DELETED_GLJOURNAL(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.gljournals.findIndex(gljournal => gljournal._id === payload._id);
      console.log(indexToDelete);
      let gljournals = [...state.gljournals];
      gljournals.splice(indexToDelete, 1);
      state = Object.assign(state, {
        gljournals: [...gljournals],
        isDeleting: false,
        idToDelete: null,
        gljournalsMessage: 'GLJournal has been Deleted!',
      });
    },
    DELETE_ROLE_SUCCESS(state, payload) {
      let indexToDelete = state.roles.findIndex(role => role._id === payload._id);
      console.log(indexToDelete);
      let roles = [...state.roles];
      roles.splice(indexToDelete, 1);
      state = Object.assign(state, {
        roles: [...roles],
        isDeleting: false,
        idToDelete: null,
        rolesMessage: 'Role has been Deleted!',
      });
    },
    DELETING_GLJOURNAL(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteGLJournalRequest({dispatch}, payload) {
      dispatch("deletingGLJournal", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.accountxc.com:3100/delete/gl-journal/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        dispatch("deleteGLJournal", {_id: response.data._id});
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deleteGLTransactionRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/delete/gl-transaction/" + payload._id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){return null}
    },
    async insertGLJournalRequest({dispatch}, payload) {
      try {
        dispatch("receivingGLJournals");
        var token = localStorage.getItem('token');
        let url = 'https://api.accountxc.com:3100/insert/gl-journal';
        let data = payload;
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        console.log('here2');
        let response = await axios({method: "post", url: url, headers: headers, data: data});
        await dispatch("receiveGLJournal", response.data);
        return response.data;
      } catch (error) {
        console.log(error.data);
      }

    },
    async insertGLTransactionRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/insert/gl-transaction/" + payload.journalid;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        return response.data;
      }
      catch(e){console.log(e)}
    },
    async getGLJournalsRequest({dispatch}) {
      dispatch("receivingGLJournals");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/gl-journals';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        console.log('gljournals', response.data)
        dispatch("receiveGLJournals", response.data);
      })
    },
    async findGLJournalsRequest({dispatch}, payload) {
      try{
        dispatch("receivingGLJournals");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/find/gl-journals';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveGLJournals", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateGLJournalRequest({dispatch}, payload) {
      dispatch("updatingGLJournal");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/gl-journal/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateGLJournal", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateGLTransaction({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/gl-transaction/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    clearGLJournals({commit}) {
      commit("CLEAR_GLJOURNALS")
    },
    receiveGLJournals({commit}, payload) {
      commit("RECEIVED_GLJOURNALS", payload)
    },
    receivingGLJournals({commit}) {
      commit("RECEIVING_GLJOURNALS")
    },
    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },
    receiveGLJournal({commit}, payload) {
      commit("RECEIVED_GLJOURNAL", payload)
    },
    receivingGLJournal({commit}) {
      commit("RECEIVING_GLJOURNAL")
    },
    updateGLJournal({commit}, payload) {
      commit("UPDATED_GLJOURNAL", payload)
    },
    updatingGLJournal({commit}) {
      commit("UPDATING_GLJOURNAL")
    },
    deleteGLJournal({commit}, payload) {
      commit("DELETED_GLJOURNAL", payload)
    },
    deletingGLJournal({commit}, payload) {
      commit("DELETING_GLJOURNAL", payload)
    }
  },
};
